import { render, staticRenderFns } from "./TeacherEditPassword.vue?vue&type=template&id=0cc03858"
import script from "./TeacherEditPassword.vue?vue&type=script&lang=js"
export * from "./TeacherEditPassword.vue?vue&type=script&lang=js"
import style0 from "./TeacherEditPassword.vue?vue&type=style&index=0&id=0cc03858&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports